export { CounterDisplay, type CounterDisplayProps } from './CounterDisplay';

